function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0m2.56 5.857c0 .17-.07.237-.237.237-.318 0-.637 0-.954.013s-.49.157-.49.489c-.007.355 0 .703 0 1.066h1.363c.194 0 .26.066.26.262v1.428c0 .193-.061.253-.257.254H9.867v3.854c0 .206-.064.27-.268.27H8.117c-.18 0-.25-.069-.25-.248v-3.87H6.692c-.185 0-.251-.067-.251-.253V7.922c0-.184.07-.254.252-.254h1.176V6.632a2.6 2.6 0 0 1 .323-1.334 1.96 1.96 0 0 1 1.058-.879c.29-.105.597-.158.906-.156h1.164c.167 0 .236.074.236.237q.008.683.005 1.357",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFb);
export default __webpack_public_path__ + "static/media/ic_fb.4e5422e08095d0cf11dd7ea35097263a.svg";
export { ForwardRef as ReactComponent };